import {
  sanitizeSupabaseEnv,
  serviceKeyProblem,
  type ServiceKeyProblem,
} from "@/lib/supabaseEnv";

// Bersihkan nilai env Supabase: buang karakter non-ASCII / tak terlihat
// (zero-width space, smart quote, NBSP, newline, dll.) yang kadang ikut
// ter-paste di dashboard hosting. Header HTTP hanya boleh ISO-8859-1; karakter
// liar membuat fetch gagal: "String contains non ISO-8859-1 code point".
// URL & key Supabase yang valid SELALU ASCII, jadi pembersihan ini aman
// (tidak mengubah nilai yang sudah benar).
//
// Implementasinya pindah ke `@/lib/supabaseEnv` (modul MURNI, diuji) supaya
// hanya ada SATU definisi — dulu pembersihan ini cuma dipakai URL & anon key,
// sementara service role key dibaca mentah; lihat catatan di modul itu.
const sanitizeEnv = sanitizeSupabaseEnv;

export const supabaseUrl = sanitizeEnv(process.env.NEXT_PUBLIC_SUPABASE_URL);
export const supabaseAnonKey = sanitizeEnv(process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY);

/**
 * Plafon satu pembacaan setelan STOREFRONT dari REST (`brandingServer` /
 * `appearanceServer`) — nama toko, logo, tema, banner beranda.
 *
 * `fetch` tidak punya timeout bawaan, jadi tanpa ini Supabase yang MENGGANTUNG
 * membuat beranda toko menunggu sampai gerbang di depan Supabase menyerah pada
 * detik ke-20. Terukur di produksi 2026-09-12 saat instans berhenti menerima
 * koneksi: TTFB `galeastore.id` 19,1 dtk, padahal kedua pembaca ini sudah
 * fail-open ke `FALLBACK` — nilai bawaannya sudah siap, yang kurang hanya
 * keberanian berhenti menunggu.
 *
 * 3 detik, SAMA dengan `RESOLVE_TIMEOUT_MS` di `storeContextServer.ts` yang
 * sudah memakai pola ini lebih dulu (dan sampai sekarang satu-satunya pembaca
 * server yang punya timeout). Sengaja sedikit lebih longgar dari plafon 2,5 dtk
 * milik setelan platform: kedua pembaca ini menentukan IDENTITAS toko yang
 * dilihat pembeli (nama & logo), jadi hasil yang benar lebih pantas ditunggu
 * daripada teks etalase platform.
 */
export const STOREFRONT_READ_TIMEOUT_MS = 3_000;

/**
 * Kunci SERVICE ROLE (rahasia, server-only) — kini melewati pembersih yang
 * SAMA dengan anon key. Jangan pernah membaca `process.env
 * .SUPABASE_SERVICE_ROLE_KEY` langsung lagi: satu newline sisa salin-tempel
 * di panel hosting membuat SELURUH jalur service role menjawab 401 "Invalid
 * API key" sementara jalur anon tetap sehat — persis bug ganti/reset password
 * pasca-migrasi region 2026-08.
 */
export const supabaseServiceRoleKey = sanitizeEnv(
  process.env.SUPABASE_SERVICE_ROLE_KEY
);

/**
 * Masalah pada kunci service role yang bisa dibuktikan dari nilainya sendiri
 * (kosong / salah role / milik project lain) — `null` bila tak ada.
 * Dievaluasi sekali saat modul dimuat; env tidak berubah saat runtime.
 */
export const serviceRoleKeyProblem: ServiceKeyProblem | null = serviceKeyProblem(
  supabaseUrl,
  supabaseServiceRoleKey
);
